import React from "react";

import { Routing } from "@common/_constants";
import { Button } from "@common/components/Atoms/Button";
import Modal from "@common/components/Molecules/Modal";

interface ShowCompanyAgreementProps {
    isOpen: boolean,
    onOkay: () => void,
    onCancel: () => void,
    closeModal: () => void
};

export const ShowCompanyAgreement: React.SFC<ShowCompanyAgreementProps> = (props: ShowCompanyAgreementProps) => (
    <Modal isOpen={props.isOpen} closeModal={props.closeModal}>
        <div className="c-block">
            <div className="c-block__title">just a reminder....</div>
            <div className="c-block__body">
                <p>
                    Many Relode agents share job opportunities using their online networks and
                    social media resources.
                </p>
                <p>
                    Per our agent agreement, please keep in mind that sharing client name, salary,
                    or representing yourself as the client or a Relode employee will results in
                    suspension of your Relode account.
                </p>
                <p>
                    For reference, check out Relode's{" "}
                    <a className="c-link" target="_blank" href={Routing.Marketing.POLICY_TERMS}>
                        Terms of Use
                    </a>.
                </p>
            </div>
        </div>
        <div className="c-modal__footer">
            <div className="c-modal__footer-left">
                <Button id="show-company-agreement-team-button" green={true} onClick={props.onOkay}>
                    Show me the company/team
                </Button>
            </div>
            <div className="c-modal__footer-right">
                <Button id="show-company-agreement-cancel-button" onClick={props.onCancel}>Cancel</Button>
            </div>
        </div>
    </Modal>
);

